import { useOutletContext } from 'react-router-dom';

import { useTypedParams } from '@sorare/routing';

import type { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';

import { TopPlayers } from 'components/topPlayers/TopPlayers';
import type { Filters } from 'components/topPlayers/TopPlayers/TopPlayersFilters/types';

import type { PageParams } from './__generated__/routeParams';

const TopPlayersPage = () => {
  const { fixture, eventType } = useTypedParams<PageParams>();
  const { filters } = useOutletContext<{
    fixture: string;
    filters: Filters;
  }>();

  return (
    <TopPlayers
      eventType={eventType as So5FixtureEvent}
      fixture={fixture}
      filters={filters}
    />
  );
};

export default TopPlayersPage;
